import { Container, Title, Text, Button, Stack, Box } from "@mantine/core";
import { IconRocket } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import { motion } from "framer-motion";
import { ContactFormModal } from "./ContactFormModal";

const ease = [0.25, 0.46, 0.45, 0.94] as const;

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease } },
};

export function CTASection() {
  const [
    contactModalOpened,
    { open: openContactModal, close: closeContactModal },
  ] = useDisclosure(false);

  return (
    <Box
      component="section"
      py={100}
      style={{
        background: "linear-gradient(135deg, #4a8c71 0%, #356651 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative blobs */}
      <Box
        style={{
          position: "absolute",
          top: "0",
          right: "10%",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)",
          filter: "blur(60px)",
          pointerEvents: "none",
        }}
      />
      <Box
        style={{
          position: "absolute",
          bottom: "0",
          left: "10%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)",
          filter: "blur(60px)",
          pointerEvents: "none",
        }}
      />

      <Container size="md" style={{ position: "relative", zIndex: 1 }}>
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <Stack align="center" gap="xl">
            <motion.div variants={item}>
              <Title order={2} size="2.5rem" fw={700} ta="center" c="white">
                Ready to Modernize Your Group Home?
              </Title>
            </motion.div>

            <motion.div variants={item}>
              <Text size="xl" c="white" ta="center" maw={700} opacity={0.95}>
                LivingSyncs helps group homes deliver better care and streamline
                operations. Schedule a personalized demo today.
              </Text>
            </motion.div>

            <motion.div variants={item}>
              <Stack align="center" gap="md" mt="md">
                <Button
                  size="xl"
                  variant="white"
                  color="healthyGreen"
                  leftSection={<IconRocket size={20} />}
                  styles={{
                    root: {
                      transition: "all 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
                      },
                    },
                  }}
                  onClick={openContactModal}
                >
                  Request a Demo
                </Button>
                <Text size="sm" c="white" opacity={0.9}>
                  Personalized onboarding · White-glove setup · Enterprise-ready
                </Text>
              </Stack>
            </motion.div>

            <motion.div variants={item}>
              <Stack align="center" gap="xs" mt="xl">
                <Text size="sm" c="white" opacity={0.8}>
                  Built for group homes and residential care providers
                </Text>
                <Text size="xs" c="white" opacity={0.7}>
                  HIPAA-Ready · Bank-Level Encryption
                </Text>
              </Stack>
            </motion.div>
          </Stack>
        </motion.div>
      </Container>

      <ContactFormModal
        opened={contactModalOpened}
        onClose={closeContactModal}
      />
    </Box>
  );
}
